import * as React from "react";
import * as S from "@styled";
import { keyboardIcon, recenterIcon } from "shared/icons/svgHelpers";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeType } from "shared/styles/theme";

const CanvasCustomControls: React.FC<ICanvasCustomControls> = (props) => {
    const [theme] = useUserTheme();

    React.useEffect(() => {
        const handleKeydownEventForResetZoom = (ev: KeyboardEvent) => {
            if (!ev.repeat && (ev.ctrlKey || ev.metaKey) && ev.key === '9') {
                ev.preventDefault();
                props.onResetZoom();
            }
        }

        document.addEventListener('keydown', handleKeydownEventForResetZoom);

        return () => document.removeEventListener('keydown', handleKeydownEventForResetZoom);
    }, [props]);

    const fillColor = theme === ThemeType.light ? S.Colors.black : S.Colors.grey_4;

    return (
        <S.CanvasCustomControls id="zoom-controls-selector" className="pointer">
            <div onClick={props.onResetZoom} title="Reset zoom and graph position" style={{ display: "flex", justifyContent: "center" }}>
                <div dangerouslySetInnerHTML={{ __html: recenterIcon(fillColor) }} />
            </div>
            {props.onToggleMinimap && (
                <div onClick={props.onToggleMinimap} title="Toggle minimap">
                    <i className="ci-map" style={{ color: fillColor }} />
                </div>
            )}
            {props.onShowKeyboardShortcuts && (
                <div onClick={props.onShowKeyboardShortcuts} title="Show keyboard shortcuts">
                    <div dangerouslySetInnerHTML={{ __html: keyboardIcon(fillColor) }} />
                </div>
            )}
        </S.CanvasCustomControls>
    )
}

interface ICanvasCustomControls {
    onResetZoom: () => void;
    onToggleMinimap?: () => void;
    onShowKeyboardShortcuts?: () => void;
}

export default CanvasCustomControls;